import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useLocation for current path
import Soap from '../images/soap.webp';
import Shampoo from '../images/shampoo.webp';
import Headerimg from '../images/headerimg.webp';
import Neem from '../images/neem.webp';

import "./header.css";

const HeaderNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current path

  // Helper function to determine if the link is active
  const isActive = (path) => {
    // Check if the path matches the current location, including root path
    if (path === '/' && (location.pathname === '/' || location.pathname === '/')) {
      return true;
    }
    return location.pathname === `/${path}`;
  };

  return (
    <div>
      {/* Header Section (Always rendered) */}
      <header>
        <img src={Headerimg} id="brand-name" alt="Brand" onDoubleClick={() => navigate("/admin")} />
        <section id="soap-shampoo">
          <img src={Soap} id="soap" alt="Soap" />
          <img src={Shampoo} id="shampoo" alt="Shampoo" />
        </section>
        <img src={Neem} id="neem" alt="Neem" />
      </header>

      {/* Conditionally render Navbar Section (Only render if not on /admin path) */}
      {(location.pathname !== '/admin' && location.pathname !== '/login') && (
        <div className="navbar" style={{ background: 'black', color: 'white' }}>
          <ul className="navbar-links" style={{ background: 'black', color: 'white' }}>
            {/* All Products button */}
            <li onClick={() => navigate('/')} className={isActive('/') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                All Products
              </button>
            </li>

            {/* Popular Products */}
            <li onClick={() => navigate('/popular')} className={isActive('/popular') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                Most Popular Products
              </button>
            </li>

            {/* Other Links */}
            <li onClick={() => navigate('/new-launch-product')} className={isActive('/new-launch') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                New Launch
              </button>
            </li>

            {/* Shop by Concern */}
            <li onClick={() => navigate('/concern')} className={isActive('/concern') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                Shop by Concern
              </button>
            </li>

            {/* About Us */}
            <li onClick={() => navigate('/about')} className={isActive('/about') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                About Us
              </button>
            </li>

            {/* Contact Us */}
            <li onClick={() => navigate('/contact')} className={isActive('/contact') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                Feedback / enquiry

              </button>
            </li>

            {/* Customer Reviews */}
            <li onClick={() => navigate('/review')} className={isActive('/review') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                Customer Review
              </button>
            </li>

            <li onClick={() => navigate('/how-to-order')} className={isActive('/how-to-order') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                How To Order
              </button>
            </li>
            <li onClick={() => navigate('/faq')} className={isActive('/faq') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                FAQ
              </button>
            </li>
             <li onClick={() => navigate('/terms_conditions')} className={isActive('/terms_conditions') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
              Terms & Conditions
              </button>
            </li>
            
             <li onClick={() => navigate('/blog')} className={isActive('/blog') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                Blog
              </button>
            </li>
            <li onClick={() => navigate('/my-orders')} className={isActive('/my-orders') ? 'active' : ''}>
              <button className="navbar-btn" style={{ color: 'white' }}>
                My Orders
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default HeaderNavbar;
